<!--
 * @Author: pengyong
 * @Date: 2020-11-13 21:13:50
 * @LastEditors: pengyong
 * @LastEditTime: 2020-11-29 15:00:09
 * @Description:
 * @FilePath: /exhibit/src/views/login/index.vue
-->
<template>
    <Wrapper :modalWidth="7" :modalHeight="12">
        <div class="login-wrapper">
            <img src="../../../static/logo.png" alt="">
            <div class="login-role">
                <span class="login-role-visitor">观众登陆</span>
                <span class="login-role-exhibition" @click="goPathExhibition()">参展商登录入口>></span>
            </div>
            <div class="tabs">
                <div :class="['tab', current === list.id && 'current']" v-for="list in tabs" :key="list.id" @click="changeTab(list)">
                    {{ list.text }}
                </div>
            </div>
            <div class="form">
                <template v-if="current === 0">
                    <div class="form-item">
                        <div class="prefix prefix-account">
                            <img :src="require('@/assets/account.png')" alt="" />
                        </div>
                        <input v-model="account" class="ipt" type="text" :placeholder="$t('login').accountPlaceHolder" />
                    </div>
                    <div class="form-item">
                        <div class="prefix prefix-psw">
                            <img :src="require('@/assets/password.png')" alt="" />
                        </div>
                        <input v-model="password" class="ipt" :type="showPassword ? 'text' : 'password'" :placeholder="$t('login').pswPlaceHolder" />
                        <div class="suffix">
                            <img
                                :class="[showPassword ? 'eye-hide' : 'eye']"
                                @click="showPassword = !showPassword"
                                :src="showPassword ? require('@/assets/eye-hide.png') : require('@/assets/eye.png')"
                                alt=""
                            />
                        </div>
                    </div>
                    <div class="form-item form-item-code">
                        <div class="form-item-left" style="padding-left:15px;">
                            <input class="ipt" v-model="captcha" :placeholder="$t('login').imgPlaceHolder" type="text" />
                        </div>
                        <div class="form-item-right" @click="getCaptcha">
                            <img style="width:100%;height:100%;border-radius: 13px;" :src="captchaImg" alt="" />
                        </div>
                    </div>
                    <div class="action">
                        <div class="auto-login" @click="handleToggleLogin">
                            <div class="checked" v-if="checked">
                                <img :src="require('@/assets/confirm.png')" alt="" />
                            </div>
                            <div class="unchecked" v-else></div>
                            {{ $t("login").autoLogin }}
                        </div>
                        <!-- <router-link to="/forget">{{ $t("login").forget }}</router-link> -->
                    </div>
                </template>
                <template v-else>
                    <div class="form-item">
                        <div class="prefix prefix-account">
                            <img :src="require('@/assets/account.png')" alt="" />
                        </div>
                        <input
                            class="ipt"
                            maxlength="11"
                            type="text"
                            v-if="current === 1"
                            v-model="phone"
                            :placeholder="$t('login').phonePlaceholder"
                        />
                        <input class="ipt" type="text" v-else v-model="email" :placeholder="$t('login').emailPlaceholder" />
                    </div>
                    <div class="form-item form-item-code">
                        <div class="form-item-left">
                            <div class="prefix prefix-code">
                                <img :src="require('@/assets/code.png')" alt="" />
                            </div>
                            <input
                                class="ipt"
                                maxlength="6"
                                v-model="phoneCode"
                                v-if="current === 1"
                                :placeholder="$t('login').codePlaceholder"
                                type="text"
                            />
                            <input class="ipt" maxlength="6" v-else v-model="emailCode" :placeholder="$t('login').codePlaceholder" type="text" />
                        </div>
                        <div :class="['form-item-right', disabledSendCode && 'disabled']" @click="handleGetCode">
                            {{ hasSend ? count : $t("login").sendCode }}
                        </div>
                    </div>
                </template>
                <CommonButton @click="handleLogin" :loading="loading" style="margin-top: 24px;margin-bottom:13px;" :disabled="disabled">
                    {{ $t("login").login }}
                </CommonButton>
                <div class="tip">
                    {{ $t("login").tip }}<router-link to="/mobileRegister" tag="span">{{ $t("login").registerTip }}</router-link>
                </div>
            </div>
        </div>
    </Wrapper>
</template>

<script>
import Wrapper from "@/components/CommomMobileWrapper";
import CommonButton from "@/components/CommonButton";
import api from "@/api";
import encrypt from "@/utils/encrypt";

export default {
    components: {
        Wrapper,
        CommonButton
    },
    data() {
        return {
            current: 0,
            showPassword: false,
            checked: false,
            hasSend: false,
            count: 60,
            account: "",
            password: "",
            phone: "",
            phoneCode: "",
            email: "",
            emailCode: "",
            loading: false,
            captcha: "",
            captchaImg: "",
            captchaKey: ""
        };
    },
    computed: {
        disabledSendCode() {
            if (this.current === 1 && !this.phone) {
                return true;
            }
            if (this.current === 2 && !this.email) {
                return true;
            }
            return this.hasSend;
        },
        disabled() {
            if (this.current === 0) {
                return !(this.account && this.password && this.captcha);
            } else if (this.current === 1) {
                return !(this.phone && this.phoneCode);
            }
            return !(this.email && this.emailCode);
        },
        tabs() {
            const { accountLogin, phoneLogin, emailLogin } = this.$t("login");
            return [
                { text: accountLogin, id: 0 },
                { text: phoneLogin, id: 1 },
                { text: emailLogin, id: 2 }
            ];
        },
        goPathExhibition(){
            let language = localStorage.getItem("language") || "zh"
            window.location.href = `https://sso.cloudvhall.com/#/?redirect=https%3A%2F%2Fmanage.cloudvhall.com%2Fexhibitor%2F&paas=shidai&language=${language}`;
        }
    },
    mounted() {
        if (localStorage.getItem("autoLogin")) {
            // this.checked = true;
            // this.account = localStorage.getItem("account") || "";
            // this.password = localStorage.getItem("password") || "";
            // this.handleLogin();
        }
        this.getCaptcha();
    },
    methods: {
        getCaptcha() {
            api.getCaptcha().then((res) => {
                if (res.res === 1) {
                    this.captchaImg = res.captcha.img;
                    this.captchaKey = res.captcha.key;
                }
            });
        },
        changeTab(list) {
            this.current = list.id;
            this.loading = false;
            this.hasSend = false;
            this.count = 60;
        },
        handleToggleLogin() {
            this.checked = !this.checked;
        },
        async handleGetCode() {
            if (this.disabledSendCode) return;
            this.hasSend = true;
            let res = {};
            if (this.current === 1) {
                res = await api.sendSmsCode({ phone: this.phone });
            } else {
                res = await api.sendEmailCode({ email: this.email });
            }
            if (res.res === 1) {
                this.count = 60;
                clearInterval(this.timer);
                this.startTime = new Date().getTime();
                this.timer = setInterval(() => {
                    let countDownTime = Math.round(60 - (new Date().getTime() - this.startTime) / 1000);
                    if (countDownTime <= 0) {
                        this.hasSend = false;
                        this.count = 60;
                        clearInterval(this.timer);
                    } else {
                        this.count = countDownTime;
                    }
                }, 1000);
            } else {
                this.hasSend = false;
                this.count = 60;
                clearInterval(this.timer);
                this.$notify(res.message);
            }
        },
        handleSaveLocal() {
            if (this.checked) {
                if (this.current === 0) {
                    localStorage.setItem("autoLogin", true);
                    localStorage.setItem("account", this.account);
                    localStorage.setItem("password", this.password);
                }
            } else {
                if (this.current === 0) {
                    localStorage.removeItem("autoLogin");
                }
            }
        },
        async handleLogin() {
            this.loading = true;
            let res = {};
            switch (this.current) {
                case 0:
                    res = await api.login({
                        name: this.account,
                        password: encrypt(this.password, this.captchaKey),
                        captcha: this.captcha,
                        cpkey: this.captchaKey
                    });
                    break;
                case 1:
                    res = await api.smslogin({ phone: this.phone, verify_code: this.phoneCode });
                    break;
                case 2:
                    res = await api.maillogin({ email: this.email, verify_code: this.emailCode });
                    break;
            }
            this.loading = false;
            if (res.res === 1) {
                localStorage.setItem("access_token", res.access_token);
                localStorage.setItem("token_type", res.token_type);
                this.handleSaveLocal();
                this.$router.push("/home");
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.login-wrapper {
    padding: .5rem;
    img{
        width: 6rem;
    }
    .login-role{
        margin: 42px 0 30px;
        display: flex;
        justify-content: space-between;
        .login-role-visitor{
            font-size: 16px;
            font-weight: 500;
            color: #49546B;
            line-height: 22px;
        }
        .login-role-exhibition{
            font-size: 16px;
            font-weight: 400;
            color: #0D5095;
            line-height: 22px;
            cursor: pointer;
        }
    }
    .tabs {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .tab {
            cursor: default;
            height: 28px;
            font-size: 16px;
            font-weight: 500;
            white-space: nowrap;
            color: rgba(9, 70, 140, 0.4);
            line-height: 28px;
            &.current {
                color: rgba(9, 70, 140, 1);
            }
        }
    }
    .form {
        padding-top: 40px;
        .form-item {
            height: 40px;
            background: rgba(9, 70, 140, 0.1);
            border-radius: 13px;
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            overflow: hidden;
            .prefix,
            .suffix {
                width: 43px;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
            }
            .prefix-account {
                img {
                    width: 16px;
                    height: 16px;
                }
            }
            .prefix-psw {
                img {
                    width: 13px;
                    height: 16px;
                }
            }
            .prefix-code {
                img {
                    width: 16px;
                    height: 19px;
                }
            }
            .ipt {
                height: 40px;
                line-height: 40px;
                flex: 1;
                background: transparent;
                font-size: 16px;
                color: rgba(9, 70, 140, 1);
            }
            .eye-hide {
                width: 16px;
                height: 7px;
                cursor: pointer;
            }
            .eye {
                width: 16px;
                height: 12px;
                cursor: pointer;
            }
        }
        .form-item-code {
            background: transparent;
            border-radius: none;
            overflow: inherit;
            .form-item-left {
                width: 200px;
                background: rgba(9, 70, 140, 0.1);
                border-radius: 13px;
                display: flex;
                align-items: center;
            }
            .form-item-right {
                width: 113px;
                height: 40px;
                line-height: 40px;
                background: rgba(9, 70, 140, 1);
                border-radius: 13px;
                text-align: center;
                font-size: 16px;
                color: #ffffff;
                cursor: pointer;
                &.disabled {
                    cursor: not-allowed;
                    background: rgba(9, 70, 140, 0.3);
                }
            }
        }
        .action {
            font-size: 11px;
            font-weight: 400;
            color: #5f7185;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .auto-login {
                display: flex;
                align-items: center;
                cursor: pointer;
                user-select: none;
                .checked,
                .unchecked {
                    width: 16px;
                    height: 16px;
                    border-radius: 13px;
                    margin-right: 7px;
                    margin-top: -2px;
                }
                .checked {
                    background: rgba(9, 70, 140, 1);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    img {
                        width: 11px;
                        height: 7px;
                        margin-top: 2px;
                    }
                }
                .unchecked {
                    background: rgba(9, 70, 140, 0.2);
                }
            }
        }
        .tip {
            font-size: 11px;
            font-weight: 500;
            color: #5f7185;
            text-align: center;
            cursor: pointer;
            span {
                color: rgba(9, 70, 140, 1);
                text-decoration: underline;
                font-weight: 500;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/mobileLogin/index.vue